// One route contract for generated pages, browser navigation and early redirects.
import { matchLocale, resolveLocale } from './core.mjs';
export const pageSlugs = Object.freeze(['', 'it-consultation', 'app-development', 'fynlink', 'retailist-app', 'retailist-store', 'retailist-cloud', 'retailist-ai', 'psynera', 'privacy-policy', 'tos', 'cookie-policy']);
export const siteOrigin = 'https://algorithmic.network';

export function pageRoute(pathname, { languages, pages = pageSlugs } = {}) {
  let segments;
  try { segments = decodeURIComponent(pathname).split('/').filter(Boolean); }
  catch { return null; }
  const language = languages.find(value => value.code.toLowerCase() === segments[0]?.toLowerCase());
  if (language) segments.shift();
  if (segments.length > 1) return null;
  const name = (segments[0] ?? '').replace(/\.html$/, '');
  const page = name === 'index' ? '' : name;
  return pages.includes(page) ? { page, locale: language?.code ?? null } : null;
}

export function localePath(page, locale) {
  return `/${locale.toLowerCase()}/${page ? `${page}/` : ''}`;
}

export function localizedUrl(value, locale, base, registry) {
  const url = new URL(value, base);
  if (url.origin !== new URL(base).origin) return null;
  const route = pageRoute(url.pathname, registry);
  if (!route) return null;
  url.pathname = localePath(route.page, locale);
  url.searchParams.delete('lang');
  return url;
}

// Serialized into the document head before styles/body. Existing helpers are
// included by the builder, so browser preference matching has one implementation.
export function localeBootstrap(config) {
  const url = new URL(location.href);
  const route = pageRoute(url.pathname, config);
  if (!route) return;
  let saved;
  try { saved = localStorage.getItem(config.storageKey); } catch { /* Optional storage. */ }
  const query = matchLocale(url.searchParams.get('lang'), config.languages);
  const locale = query ?? route.locale ?? resolveLocale({ saved, browser: navigator.languages ?? [navigator.language], ...config });
  const pathname = localePath(route.page, locale);
  if (pathname === url.pathname && !url.searchParams.has('lang')) return;
  url.pathname = pathname;
  url.searchParams.delete('lang');
  location.replace(url.pathname + url.search + url.hash);
}

export function syncLocaleAddress(locale, registry) {
  const url = localizedUrl(location.href, locale, location.href, registry);
  if (!url) return;
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  const base = document.querySelector('base[href]');
  if (base) base.href = url.pathname;
  const canonical = document.querySelector('link[rel="canonical"]');
  const address = siteOrigin + url.pathname;
  if (canonical) canonical.href = address;
  document.querySelector('meta[property="og:url"]')?.setAttribute('content', address);
}
